export const formatUrl = (url) => {
  if (url && !url.startsWith("https://") && !url.startsWith("http://")) {
    return `https://${url}`;
  }
  return url;
};

export const getYouTubeVideoId = (url) => {
  if (!url) return null;
  const regex = /[?&]v=([^&]+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

export const formatDateDetails = (dateString) => {
  const date = new Date(dateString);

  return {
    Full_Date: date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }),
    Month: date.toLocaleDateString("en-US", { month: "short" }),
    Year: date.getFullYear(),
    Date: date.getDate(),
    Day: date.toLocaleDateString("en-US", { weekday: "long" }),
  };
};

export const truncateWords = (text = "", wordLimit = 10) => {
  const words = text.split(" ");
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(" ") + "..."
    : text;
};

export const convertMultipleNewlinesToBR = (text) => {
  let replaced = text.replace(/([^\n])\n(?!\n)/g, '$1<br />');
  replaced = replaced.replace(/(\s*\n\s*){2,}/g, () => {
    return '<br /><span style="display:block; margin-bottom:8px;"></span>';
  });

  return replaced;
};
